import React, { useState } from 'react';
import { Button, Icon } from '../../../../../../common/components';
import { PanelGroup } from 'react-bootstrap';
import DocumentCollapsePanel from '../DocumentCollapsePanel';
import { connect } from 'react-redux';
import { actions as productActions } from '../../../../redux/productActions';
import './MultipleInsurerDocuments.scss';

const Message = ({ hasDocuments, isRetrieving }) => {
  if (isRetrieving && !hasDocuments) {
    return ( <div  className={'multiple-insurer-documents--msg'} >Retrieving Documents<Icon spin name="spinner" /></div>);
  }
  if (!isRetrieving && !hasDocuments) {
    return (<div className={'multiple-insurer-documents--msg'}>No Documents Found</div>);
  }
  return null;
};

const MultipleInsurerDocuments = ({
  productId,
  onGetProductDocuments
}) => {
  const [openContainer, setOpenContainer] = useState(false);
  const [isRetrievingDocuments, setIsRetrievingDocuments] = useState(false);
  const [documents, setDocuments] = useState([]);

  const showDocs = () => {
    setOpenContainer(!openContainer);


    if (!!documents.length){
      return ;
    }
    setIsRetrievingDocuments(true);
    return Promise.resolve(onGetProductDocuments().then((docs) => {
      setDocuments(docs);

    }).finally(() => {
      setIsRetrievingDocuments(false);
    }));
  };

  const productDocuments =  Object.values(documents?.[productId]?.product_documents ?? {}) ?? [] ;
  const insurerDocuments =  documents?.[productId]?.insurer_documents ?? {} ;
  return (
    <>
      <div className={'title-container'} onClick={showDocs}>
        <span className={'title'}>Product documents </span>
        <Icon name={openContainer ? 'minus-circle' : 'plus-circle'} />
      </div>
      {openContainer && (
        <>
          <Message hasDocuments={!!productDocuments.length} isRetrieving={isRetrievingDocuments}/>
          <div className={'documents'}>
            {productDocuments?.map((doc) => {
              return (
                <a key={doc.name} href={doc.path} target="_blank">
                  <Button size="sm" label={doc.name} />
                </a>
              );
          })}
          </div>
          <PanelGroup defaultActiveKey="1" accordion>
            {Object.keys(insurerDocuments).map((insurerName) => {
               const docs = Object.values(insurerDocuments?.[insurerName]);
              return (
                <DocumentCollapsePanel
                  key={insurerName}
                  documents={docs}
                  panelKey={insurerName}
                  headerName={insurerName}
                />
              );
            })}

          </PanelGroup>
        </>
      )}
    </>
  );
};

export default connect(
  null,
  {
    onGetProductDocuments: productActions.getProductDocuments,
  },
)(MultipleInsurerDocuments);


